module.exports = __webpack_public_path__ + "static/media/VK.2284c763.svg";